/* FaithKept — Countdown Timer */
(function() {
  function initCountdowns() {
    document.querySelectorAll('[data-fk-countdown]').forEach(function(el) {
      var end = new Date(el.dataset.fkCountdown);
      function tick() {
        var now = new Date();
        var diff = Math.max(0, end - now);
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function(n) { return String(n).padStart(2, '0'); };
        var dd = el.querySelector('[data-fk-days]');
        var dh = el.querySelector('[data-fk-hours]');
        var dm = el.querySelector('[data-fk-mins]');
        var ds = el.querySelector('[data-fk-secs]');
        if (dd) dd.textContent = pad(d);
        if (dh) dh.textContent = pad(h);
        if (dm) dm.textContent = pad(m);
        if (ds) ds.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('.fk-faq__question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.fk-faq__item');
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.fk-faq__item.open').forEach(function(i) {
          i.classList.remove('open');
        });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initCountdowns(); initFaq(); });
  } else {
    initCountdowns();
    initFaq();
  }
})();
